// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rh-0";